import type { TPromoBannerAny } from '@/features/promoBanners/types';
import type { TFetchPromoBannersArgs } from '@/helpers/api/resources';

import checkResultForError from '@/features/apollo/checkResultForError';
import { allFitters } from '@/features/promoBanners/fitters';
import { FETCH_PROMO_BANNERS_V2, type GQLPromoBannersApiAnswer } from '@/helpers/api/graphql';
import { query } from '@/helpers/api/graphql/apollo-server-only-instance';

export const fetchPromoBanners = async ({
  countryCode,
  fetchOptions,
  onResponseHeaders,
}: TFetchPromoBannersArgs): Promise<{ data: TPromoBannerAny[] }> => {
  const result = await query<GQLPromoBannersApiAnswer>({
    context: { fetchOptions, onResponseHeaders },
    query: FETCH_PROMO_BANNERS_V2,
    variables: countryCode ? { countryCode } : undefined,
  });
  const error = checkResultForError(result);
  if (error) throw error;
  // TODO: Unwrap result
  return { data: allFitters(result?.data?.promoBannersV2) || ([] as TPromoBannerAny[]) };
};
